<template>
  <div class="p-5 flex justify-center items-center w-full">
    <div class="mx-auto" :class="label ? 'pt-5' : ''">
      <alert
        v-if="label"
        :message="label"
        level="warning"
        class="px-3 py-2"
      ></alert>
      <div
        class="flex items-center justify-center"
        :class="label ? 'pt-5' : ''"
      >
        <new-refill-button :amount="amountForNextAction"></new-refill-button>
      </div>
    </div>
  </div>
</template>

<script>
import NewRefillButton from "./Menu/NewRefill";

export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    submittingProject: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: { NewRefillButton },
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    amountForNextAction() {
      let amount = 0 - this.$store.state.account.safe.amount.raw;
      if (this.submittingProject) {
        amount += this.$store.state.account.safe.amount.min_safe_to_submit;
      }

      return parseInt(amount) + 1;
    },
  },
  mounted() {},
};
</script>

<style></style>
